import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { poDisclaimerRepository } from '../data-access/repositories/PODisclaimerRepository'

const base = ['po-disclaimer-label']

export const poDisclaimerLabelQueryConfig = {
  all: () => ({
    queryKey: buildQueryKey(base),
  }),
  list: (params: { page: number; pageSize: number }) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () =>
      poDisclaimerRepository.list({
        active: true,
        model_type: 1,
        page: params.page,
        page_size: params.pageSize,
      }),
  }),
}
